<h2 mat-dialog-title class="bold">Bienvenue sur la nouvelle version de {{app_name_long}}</h2>
<mat-dialog-content class="mat-typography text-justify" [ngClass]="{'about-mat-dialog-content': client_name === 'national'}">
  
  @if (client_name === 'national') {
    <p class="bold">{{app_name_long}} - version T2 2025</p>

    <h3 class="uppercased" style="margin: 0 0 0px;">GESTION DES CONTRATS</h3>
    <ul style="margin-bottom: 0.5rem; text-align: justify;">
      <li style="text-align: justify;">Formulaire de demande : les contrats supprimés sont affichés annulés&barrés et restent visibles jusqu'à 500j après leur date d'annulation.</li>
    </ul>

    <h3 class="uppercased" style="margin: 0 0 0px;">PRIORISATION DES DEMANDES</h3>
    <ul style="margin-bottom: 0.5rem; text-align: justify;">
      <li style="text-align: justify;">TABLEAUX : Mise en évidence d'une date d'Échéance souhaitée proche (à - de 5jours) en rouge dans les tableaux des exploitants. Ils pourront filtrer dessus pour en déduire les demandes en retard de traitement.</li>
    </ul>

    <h3 class="uppercased" style="margin: 0 0 0px;">FORMULAIRE DE DEMANDE</h3>
    <ul style="margin-bottom: 0.5rem; text-align: justify;">
      <li style="text-align: justify;">Possibilité pour l'Exploitant de REPRENDRE une demande au statut 'À clôturer'/'À abandonner' afin de la repasser à 'En cours'.</li>
      <li style="text-align: justify;">Régularisation d’une demande - Ajustement de la Règle de remplissage de la "Date réelle de clôture" sans saisi de la "Date réelle de réception" de la demande.</li>
    </ul>

    <h3 class="uppercased" style="margin: 0 0 0px;">NOTIFICATIONS - SUPPLÉANCE</h3>
    <ul style="margin-bottom: 0.5rem; text-align: justify;">
      <li style="text-align: justify;">Création d'une Notification de passage à clôturer/à abandonner pour les collectivités non demandeur et 'acteur' Lineo. Ajout d'une préférence de notifications dédiée, par défaut activée si l'utilisateur n'a pas déjà modifié ses préférences.</li>
    </ul>
    
  }

  <br>
  <h3>Pour plus de détails, voir la <a style="text-decoration: underline;" aria-label="Fiche mémo" href="{{fiche_memo_link}}" target="_blank">Fiche Mémo</a></h3>

</mat-dialog-content>
<mat-dialog-actions>
  <p class="appVersion">Version {{appVersion}}</p>
  <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial class="uppercased mat-primary">
    Je découvre
  </button>
</mat-dialog-actions>
